// The ONE job type badge (icon + plain label on the type's locked colour). Used by every engineer
// job card, the office Scheduling board and the job sheet header, so a service, a repair and a
// call-out can never look alike. Colours come from src/lib/jobType.ts only; text on the fill is the
// scheme's own AA ink for that fill.
import { jobTypeBadgeLabel, jobTypeIcon, jobTypeStyleFor } from "../lib/jobType";

export default function JobTypeBadge({
  type,
  equipmentAsset,
  size = "md",
  className = "",
  label: labelOverride,
}: {
  type: string;
  equipmentAsset?: boolean;
  size?: "sm" | "md";
  className?: string;
  /** Session SCR1: the words a surface already states for this type (the public RFID history carries the server's own label, e.g. "LOLER inspection"). The icon and the locked fill still come from the type. */
  label?: string;
}) {
  const style = jobTypeStyleFor(type, { equipmentAsset });
  const Icon = jobTypeIcon(type);
  const label = labelOverride ?? jobTypeBadgeLabel(type, { equipmentAsset });
  const dims = size === "sm" ? "gap-1 px-1.5 py-0.5 text-[10px]" : "gap-1.5 px-2.5 py-1 text-[11px]";
  return (
    <span
      data-job-type={type}
      className={`inline-flex max-w-full flex-none items-center rounded-full font-menu font-semibold uppercase tracking-wide ${dims} ${style.bg} ${style.onBg} ${className}`}
    >
      <Icon size={size === "sm" ? 11 : 14} aria-hidden="true" className="flex-none" />
      <span className="truncate">{label}</span>
    </span>
  );
}
